// // File: src/Components/Header.jsx
// import React, { useState } from 'react';
// import userIcon from '../Assets/Img/user-profile-icon.png';
// import { useNavigate } from 'react-router-dom';

// const Header = ({ toggleSidebar }) => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const navigate = useNavigate();

//   const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

//   const logoutUser = () => {
//     sessionStorage.removeItem('auth');
//     navigate('/login');
//   };

//   return (
//     <header className="bg-white shadow sticky top-0 ">
//       <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200">
//         {/* Sidebar Toggle Button */}
//         <button
//           onClick={toggleSidebar}
//           className="text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-300 sm:hidden"
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             viewBox="0 0 24 24"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16"></path>
//           </svg>
//         </button>

//         {/* Logo */}
//         <div className="flex items-center space-x-3">
        
//         </div>

//         {/* Profile Dropdown
//         <div className="relative">
//           <button onClick={toggleDropdown} className="focus:outline-none">
//             <img
//               src={userIcon}
//               alt="User"
//               className="h-10 w-10 rounded-full border border-gray-300 object-cover"
//             />
//           </button>
//           {dropdownOpen && (
//             <ul className="absolute right-0 mt-2 w-40 bg-white text-black shadow-lg rounded-lg z-50">
//               <li>
//                 <button
//                   onClick={logoutUser}
//                   className="w-full px-4 py-2 text-left text-red-600 hover:bg-gray-100"
//                 >
//                   Logout
//                 </button>
//               </li>
//             </ul>
//           )}
//         </div> */}
//         <div className="relative">
//   <button
//     onClick={toggleDropdown}
//     className="flex items-center space-x-1 focus:outline-none"
//   >
//     <img
//       src={userIcon}
//       alt="User"
//       className="h-10 w-10 rounded-full border border-gray-300 object-cover"
//     />
//     <svg
//       className="w-4 h-4 text-gray-600"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       viewBox="0 0 24 24"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//     </svg>
//   </button>

//   {dropdownOpen && (
//     <ul className="absolute right-0 mt-2 w-40 bg-white text-black shadow-lg rounded-lg z-50">
//       <li>
//         <button
//           onClick={logoutUser}
//           className="w-full px-4 py-2 text-left text-red-600 hover:bg-gray-100"
//         >
//           Logout
//         </button>
//       </li>
//     </ul>
//   )}
// </div>

//       </div>
//     </header>
//   );
// };

// export default Header;



// File: src/Components/Header.jsx
import React, { useState } from 'react';
import userIcon from '../Assets/Img/user-profile-icon.png';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

const Header = ({ toggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const { instance, accounts } = useMsal();
  const user = accounts[0]; // Microsoft account object

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

const logoutUser = () => {
  sessionStorage.removeItem('auth');

  const isLocalhost = window.location.hostname === 'localhost';

  if (isLocalhost) {
    // Just clear session and go to login
    navigate('/login');
  } else {
    // Proper Microsoft logout for production
    instance.logoutRedirect({
      postLogoutRedirectUri: 'https://fibrebondmis.com',
    });
  }
};

  return (
    <header className="bg-white shadow sticky top-0 ">
      <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200">
        {/* Sidebar Toggle Button */}
        <button
          onClick={toggleSidebar}
          className="text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-300 sm:hidden"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Spacer or Logo (if any) */}
        <div className="text-sm text-gray-600 sm:block hidden">FibreBond MIS</div>

        {/* Profile Dropdown */}
        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="flex items-center space-x-2 focus:outline-none"
          >
            <img
              src={userIcon}
              alt="User"
              className="h-10 w-10 rounded-full border border-gray-300 object-cover"
            />
            <svg
              className="w-4 h-4 text-gray-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {dropdownOpen && (
            <ul className="absolute right-0 mt-2 w-56 bg-white text-black shadow-lg rounded-lg z-50">
              <li className="px-4 py-2 border-b text-sm text-gray-700">
                <div className="font-semibold">{user?.name || 'User'}</div>
                <div className="text-xs text-gray-500">{user?.username}</div>
              </li>
              <li>
                <button
                  onClick={logoutUser}
                  className="w-full px-4 py-2 text-left text-red-600 hover:bg-gray-100 rounded-lg z-50"
                >
                  Logout
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
